import SvgMask from '../../_Helpers/SvgMask';

interface PropsType {
	scrollPosition: number;
	setScrollPosition: React.Dispatch<React.SetStateAction<number>>;
	scrollWidth: number;
	scrollContainerRef: React.RefObject<HTMLDivElement | null>;
	onNext?: () => void;
	onPrevious?: () => void;
	canGoNext?: boolean;
	canGoPrevious?: boolean;
}

const ScrollButtons: React.FC<PropsType> = ({
	scrollPosition,
	setScrollPosition,
	scrollWidth,
	scrollContainerRef,
	onNext,
	onPrevious,
	canGoNext = true,
	canGoPrevious = true
}) => {
	// Use new stage navigation if provided, otherwise fall back to old scroll logic
	const useStageNavigation = onNext && onPrevious;

	const scrollLeftDisabled = useStageNavigation ? !canGoPrevious : scrollPosition <= 0;
	const scrollRightDisabled = useStageNavigation ? !canGoNext : scrollPosition >= scrollWidth;

	const scrollAmount = 200;

	const handleScrollButton = (direction?: 'left' | 'right') => {
		if (useStageNavigation) {
			if (direction === 'left' && onPrevious) {
				onPrevious();
			} else if (direction === 'right' && onNext) {
				onNext();
			}
			return;
		}

		// Fallback to old scroll logic
		let newScrollPosition = scrollPosition;

		if (direction === 'left') {
			newScrollPosition = Math.max(0, scrollPosition - scrollAmount);
		} else if (direction === 'right') {
			// ensure we don't scroll beyond content width
			newScrollPosition = Math.min(scrollWidth, scrollPosition + scrollAmount);
		}

		if (scrollContainerRef.current !== null) {
			scrollContainerRef.current.scrollLeft = newScrollPosition || 0;
		}

		setScrollPosition(newScrollPosition);
	};

	return (
		<>
			<button className="btn scroll-btn prev" disabled={scrollLeftDisabled} onClick={() => handleScrollButton('left')}>
				<SvgMask path="/svg/chevron-left.svg" width={16} height={16} />
			</button>

			<button
				className="btn scroll-btn next"
				disabled={scrollRightDisabled}
				onClick={() => handleScrollButton('right')}
			>
				<SvgMask path="/svg/chevron-right.svg" width={16} height={16} />
			</button>
		</>
	);
};

export default ScrollButtons;
